// removed by extract-text-webpack-plugin
module.exports = {"figure":"src-components-Image----image-module---figure---SOd_5","caption":"src-components-Image----image-module---caption---6C21O","imageButton":"src-components-Image----image-module---imageButton---3mzVX","zoomIcon":"src-components-Image----image-module---zoomIcon---12CBo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Image/image.module.sass
// module id = 360
// module chunks = 195351340454287